import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Tax from './views/Tax.vue'
import NewTax from './views/NewTax.vue'
import TaxList from './views/TaxList.vue'

Vue.use(Router)

const routes = [{ path: '/', name: 'login', meta: { title: 'console 登录' }}]

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Entry.vue')
    },
    {
      path:'/payment_list',
      name:'payment_list',
      component: () => import(/* webpackChunkName: "about" */ './views/PaymentList.vue')
    },
    {
      path:'/auth',
      name:'auth',
      component: () => import(/* webpackChunkName: "about" */ './views/Auth.vue')
    },
    {
        path:'/payment',
        name:'payment',
        component: () => import(/* webpackChunkName: "about" */ './views/Payment.vue')
    },
    {
      path:'/pay',
      name:'pay',
      component: () => import(/* webpackChunkName: "about" */ './views/Pay.vue')
    },
    {
      path:'/new_payment',
      name:'new_payment',
      component: () => import(/* webpackChunkName: "about" */ './views/NewPayment.vue')
    },
    {
      path:'/payment_success',
      name:'payment_success',
      component: () => import(/* webpackChunkName: "about" */ './views/PaymentSuccess.vue')
    },
    {
      path:'/tax',
      name:'tax',
      component: () => import(/* webpackChunkName: "about" */ './views/Tax.vue')
    },
    {
      path:'/new_tax',
      name:'new_tax',
      component: () => import(/* webpackChunkName: "about" */ './views/NewTax.vue')
    },
    {
      path:'/tax_list',
      name:'tax_list',
      component: () => import(/* webpackChunkName: "about" */ './views/TaxList.vue')
    },
    {
      path:'/invoice',
      name:'invoice',
      component: () => import(/* webpackChunkName: "about" */ './views/Invoice.vue')
    },
    {
      path:'/new_invoice',
      name:'new_invoice',
      component: () => import(/* webpackChunkName: "about" */ './views/NewInvoice.vue')
    },
    {
        path:'/detail',
        name:'detail',
        component: () => import(/* webpackChunkName: "about" */ './views/DetailInvoice.vue')
    },
    {
      path:'/mine',
      name:'mine',
      component: () => import(/* webpackChunkName: "about" */ './views/Mine.vue')
    },
    {
      path:'/suppliers',
      name:'suppliers',
      component: () => import(/* webpackChunkName: "about" */ './views/Suppliers.vue')
    },
    {
        path:'/reset_password',
        name:'reset_password',
        component: () => import(/* webpackChunkName: "about" */ './views/ResetPassword.vue')
    },
    {
        path:'/oauth',
        name:'reset_password',
        component: () => import(/* webpackChunkName: "about" */ './views/Oauth.vue')
    },
    {
        path:'/oauth_out',
        name:'reset_password',
        component: () => import(/* webpackChunkName: "about" */ './views/Oauth.vue')
    },
      {
          path:'/oauth_out',
          name:'reset_password',
          component: () => import(/* webpackChunkName: "about" */ './views/Oauth.vue')
      },
      {
          path:'/service',
          name:'service',
          component: () => import(/* webpackChunkName: "about" */ './views/Service.vue')
      },
      {
          path:'/service_detail',
          name:'service_detail',
          component: () => import(/* webpackChunkName: "about" */ './views/ServiceDetail.vue')
      },
      {
          path:'/brand_detail',
          name:'brand_detail',
          component: () => import(/* webpackChunkName: "about" */ './views/BrandDetail.vue')
      },
      {
          path:'/news',
          name:'news',
          component: () => import(/* webpackChunkName: "about" */ './views/News.vue')
      },
      {
          path:'/new_detail',
          name:'new_detail',
          component: () => import(/* webpackChunkName: "about" */ './views/NewDetail.vue')
      },
      {
          path:'/common_que',
          name:'common_que',
          component: () => import(/* webpackChunkName: "about" */ './views/CommonQues.vue')
      },
      {
          path:'/about',
          name:'about',
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
      },
      {
          path:'/amazon',
          name:'amazon',
          component: () => import(/* webpackChunkName: "about" */ './views/Amazon.vue')
      },
      {
          path:'/amazon_serve',
          name:'amazon_serve',
          component: () => import(/* webpackChunkName: "about" */ './views/AmazonServe.vue')
      },
      {
          path: '/classify',
          name: 'classify',
          component: () => import('./views/Classify.vue')
      },
      {
          path: '/shoot',
          name: 'shoot',
          component: () => import('./views/Shoot.vue')
      },
      {
          path: '/collection',
          name: 'collection',
          component: () => import('./views/Collection.vue')
      },
      {
          path: '/new_collection',
          name: 'new_collection',
          component: () => import('./views/NewCollection.vue')
      },
      {
          path: '/collection_list',
          name: 'collection_list',
          component: () => import('./views/CollectionList.vue')
      }
  ]
})
